import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Sparkles, RefreshCw } from "lucide-react";

export function AIGenerateDialog({ open, onOpenChange, clientSearch, setClientSearch, selectedClient, setSelectedClient, filteredClients, aiObjective, setAiObjective, generating, handleAIGenerate }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Sparkles className="w-5 h-5 text-emerald-500" /> KI Ernährungsplan</DialogTitle>
          <DialogDescription>Generiert einen kompletten Plan basierend auf Bioimpedanz-Daten</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase mb-1 block">Kunde auswählen *</label>
            <div className="relative">
              <Input value={clientSearch} onChange={e => { setClientSearch(e.target.value); setSelectedClient(null); }} placeholder="Name eingeben..." />
              {clientSearch && !selectedClient && (
                <div className="absolute z-20 top-full mt-1 w-full bg-white border rounded-lg shadow-lg max-h-40 overflow-auto">
                  {filteredClients.slice(0, 8).map(c => (
                    <button key={c.id} className="w-full text-left px-3 py-2 hover:bg-emerald-50 text-sm"
                      onClick={() => { setSelectedClient(c); setClientSearch(`${c.vorname} ${c.nachname}`); }}>
                      {c.vorname} {c.nachname}
                      {c.source === "bio" && <span className="ml-2 text-[9px] bg-emerald-100 text-emerald-600 px-1 py-0.5 rounded">Bioimpedanz</span>}
                    </button>
                  ))}
                </div>
              )}
            </div>
            {selectedClient && <p className="text-[10px] text-emerald-600 mt-1">Bioimpedanz-Daten und Ziele werden automatisch geladen</p>}
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase mb-1 block">Ziel</label>
            <div className="flex flex-wrap gap-1.5">
              {["Abnehmen", "Muskelaufbau", "Gesunde Ernährung", "Ausdauer", "Gewicht halten"].map(obj => (
                <button key={obj} onClick={() => setAiObjective(obj)}
                  className={`px-3 py-1.5 rounded-full text-xs font-medium border ${aiObjective === obj ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-slate-600 border-slate-200'}`}>
                  {obj}
                </button>
              ))}
            </div>
          </div>
          <Button onClick={handleAIGenerate} disabled={generating || !selectedClient} className="w-full bg-gradient-to-r from-emerald-600 to-teal-600" data-testid="ai-generate-confirm">
            {generating ? <><RefreshCw className="w-4 h-4 mr-2 animate-spin" /> Generiere Plan...</> : <><Sparkles className="w-4 h-4 mr-2" /> Plan generieren</>}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
